export default ({ cardsToFilter, category, configVisibility, id, hidePersonalDetail }) => {
    let visibleCards = [];
    const cards = hidePersonalDetail ? cardsToFilter.filter(cards => !cards.personalDetail) : cardsToFilter;
    for (const card of cards) {
        let hasVisibleField = false;
        const cardCategory = card.category || category;
        for (const fieldList of card.fields) {
            for (const field of fieldList) {
                hasVisibleField = id && cardCategory && field.id &&              
                    configVisibility[id] &&
                    configVisibility[id][cardCategory] &&
                    configVisibility[id][cardCategory][field.id];
                if (hasVisibleField) {
                    break;
                }
                if (field.type === "custom") {
                    hasVisibleField = true;
                }
                if (field.type === "contentGroup" || field.type === "group") {
                    for (const item of field.items) {
                        if (item.type === "config" || field.type === "group") {
                            hasVisibleField =
                                configVisibility[id] &&
                                configVisibility[id][cardCategory] &&
                                configVisibility[id][cardCategory][item.id];
                            if (hasVisibleField) {
                                break;
                            }
                        }
                        if (hasVisibleField) {
                            break;
                        }
                    }
                }
            }
            if (hasVisibleField) {
                break;
            }
        }
        if (hasVisibleField) {
            visibleCards.push(card);
        }
    }
    return visibleCards;
}